/**
 * @author        Pavlo Androshchuk
 * @copyright     Copyright (c) 2012, Zumper
 * @description   nav bar click
 */

import { getUser } from '@zcode-ui/web-zumper-global-state'
import { event, NAVBAR_CLICK } from '@zcode-ui/web-zumper-integrations'

import { getCurrentLocation } from '../../../inspectors/index'
import { selectFilters } from '../../filters/selectors/index'

export const trackNavBarClick =
  ({ action, city }) =>
  (dispatch, getState) => {
    const state = getState()

    const user = getUser(state)
    const filters = selectFilters(state)
    const location = getCurrentLocation(state)

    const props = { action, city }
    dispatch(event({ name: NAVBAR_CLICK, props, user, filters, location }))
  }
